import { ENV } from '@/shared/config';

import { createLotusAuthHeadersOptional } from './hostageChat';

export interface WorkflowsAvailableT {
  canOrderLabs: boolean;
  canWritePrescription: boolean;
}

export async function fetchWorkflowsAvailable(
  userId: string,
  signal?: AbortSignal
): Promise<WorkflowsAvailableT> {
  const headers = await createLotusAuthHeadersOptional();
  const res = await fetch(`${ENV.apiBaseUrl}/greenfield/care/${userId}/workflows-available`, {
    headers,
    signal,
  });
  if (!res.ok) {
    throw new Error(`workflows-available request failed: ${res.status} ${res.statusText}`);
  }
  return res.json() as Promise<WorkflowsAvailableT>;
}
